import React, { useEffect } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import CoverageQuiz from 'views/CoverageQuiz.js';

// Modal host for the "Find Your Solution" quiz. Same content also lives at
// /build-your-system for sharing.
const QuizModal = ({ open, onClose, products, onAddPackage }) => {

    useEffect(() => {
        if(!open) {
            return;
        }
        const onKeyDown = (e) => e.key === 'Escape' && onClose();
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [open, onClose]);

    return (
        <>
            <div className={`overlay ${open ? 'active' : ''}`} onClick={onClose} />

            <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: Utils.isMobile() ? 12 : 20,
                pointerEvents: open ? 'all' : 'none',
            }}>
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        width: '100%',
                        maxWidth: 950,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        backgroundColor: Appearance.colors.white,
                        borderRadius: 24,
                        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                        opacity: open ? 1 : 0,
                        transform: open ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.98)',
                        transition: 'opacity 0.3s ease, transform 0.3s ease',
                        position: 'relative',
                    }}>

                    {/* Close */}
                    <div
                        onClick={onClose}
                        style={{
                            position: 'absolute', top: 20, right: 20,
                            width: 36, height: 36, borderRadius: 18,
                            backgroundColor: Appearance.colors.offWhite,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', zIndex: 2,
                        }}>
                        <i className={'fas fa-times'} style={{ fontSize: 14, color: Appearance.colors.darkGrey }} />
                    </div>

                    <div style={{ padding: Utils.isMobile() ? '36px 22px' : '44px 44px' }}>
                        <span style={{ ...Appearance.textStyles.label(), display: 'block', marginBottom: 10 }}>
                            {'Find Your Solution'}
                        </span>
                        <h3 style={{ ...Appearance.textStyles.heading({ fontSize: Utils.isMobile() ? 24 : 30 }), marginBottom: 8 }}>
                            {'How many sensors do you need?'}
                        </h3>
                        <p style={{ ...Appearance.textStyles.body({ fontSize: 15 }), marginBottom: 32, maxWidth: 520 }}>
                            {'Answer two quick questions and we’ll recommend the right coverage for your home.'}
                        </p>

                        {open && <CoverageQuiz products={products} onAddPackage={onAddPackage} source={'modal'} />}
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuizModal;
